export const CashBudgetTags = {
  BUDGET: "budget",
  PREVENT_PLANNABLE: "preventPlannable",
};

export const CB_CONFIG_KEY = "cb-config";
